module.exports = __webpack_public_path__ + "static/media/Cube.ea475f69.png";